export const socnaColors = {
  socnaIng: '#ffc644',
  socnaSols: '#82c87d',
  socnaReseaux: '#05355b',
  socnaInternational: '#b18973',
  socnaLab: '#a90f00',
} as const;

export const muiColors = {
  primary: socnaColors.socnaIng,
  secondary: socnaColors.socnaReseaux,
  error: socnaColors.socnaLab,
  warning: socnaColors.socnaIng,
  info: '#0a648a',
  success: socnaColors.socnaSols,
} as const;
